import { arrDec } from '../../fun-js-lib/arr'
import { canvasTextFonted, canvasTextWidthFonted } from '../../fun-js-lib/canvas'
import Dot from '../../fun-js-lib/geometry/Dot'
import { textWidth } from '../canvasDraw'

/**
 * Crams text into line with max width `maxW`,
 * decreasing font if needed
 * @param {CanvasRenderingContext2D} context 
 * @param {string} text 
 * @param {number} x 
 * @param {number} y 
 * @param {number} maxW
 */
export function textCram (context, text, x, y, maxW) {
  const maxFont = 42
  let optimalFontSize = arrDec(maxFont + 1)
    .find(fontSize =>
      canvasTextWidthFonted(context, text, fontSize + 'px Arial') <= maxW)
  canvasTextFonted(context, text, new Dot({ x, y }), optimalFontSize + 'px Arial')
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} text 
 * @param {number} x 
 * @param {number} y 
 * @param {number} width 
 */
export function textCentered (context, text, x, y, width) {
  let textW = textWidth(context, text)
  context.fillText(text, x + width / 2 - textW / 2, y)
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {number} x 
 * @param {number} y 
 * @param {number} width 
 */
export function dashCentered (context, x, y, width) {
  context.fillRect(x + 5, y - 12, width - 10, 1)
}

/**
 * @param {CanvasRenderingContext2D} context 
 * @param {string} text 
 * @param {number} x 
 * @param {number} y 
 * @param {number} width 
 */
export function textCenteredOrDash (context, text, x, y, width) {
  if (text === '') {
    dashCentered(context, x, y, width)
  } else {
    textCentered(context, text, x, y, width)
  }
}